module.exports = __webpack_public_path__ + "img/joynet.b55e45da.png";